import React, { useState } from "react";
import API from "../services/api";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

function Register() {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    full_name: "",
    mobile: "",
    email: "",
    password: "",
    confirm_password: "",
    state: "",
    district: "",
    village: "",
    land_size: "",
    primary_crop: ""
  });

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (form.password !== form.confirm_password) {
      toast.error("Passwords do not match");
      return;
    }

    if (form.mobile.length < 10) {
      toast.error("Enter valid mobile number");
      return;
    }

    setLoading(true);

    try {
      await API.post("/farmer/register", {
        full_name: form.full_name,
        mobile: form.mobile,
        email: form.email,
        password: form.password,
        state: form.state,
        district: form.district,
        village: form.village,
        land_size: form.land_size,
        primary_crop: form.primary_crop
      });

      toast.success(
        "Registration successful! Your vermicompost cycle has been initialized."
      );

      setForm({
        full_name: "",
        mobile: "",
        email: "",
        password: "",
        confirm_password: "",
        state: "",
        district: "",
        village: "",
        land_size: "",
        primary_crop: ""
      });

      setTimeout(() => {
        navigate("/");
      }, 1500);

    } catch (err) {
      toast.error(
        err.response?.data?.message || "Registration failed"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-bg">
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-md-7">
            <div className="card shadow-lg border-0 auth-card">
              <div className="card-body p-5">
                <h2 className="text-center text-success mb-4 fw-bold">
                  Farmer Registration
                </h2>

                <form onSubmit={handleSubmit}>
                  <input
                    name="full_name"
                    className="form-control mb-3"
                    placeholder="Full Name"
                    value={form.full_name}
                    onChange={handleChange}
                    required
                  />

                  <input
                    name="mobile"
                    className="form-control mb-3"
                    placeholder="Mobile Number"
                    value={form.mobile}
                    onChange={handleChange}
                    required
                  />

                  <input
                    type="email"
                    name="email"
                    className="form-control mb-3"
                    placeholder="Email Address"
                    value={form.email}
                    onChange={handleChange}
                    required
                  />

                  <input
                    type="password"
                    name="password"
                    className="form-control mb-3"
                    placeholder="Password"
                    value={form.password}
                    onChange={handleChange}
                    required
                  />

                  <input
                    type="password"
                    name="confirm_password"
                    className="form-control mb-3"
                    placeholder="Confirm Password"
                    value={form.confirm_password}
                    onChange={handleChange}
                    required
                  />

                  <input
                    name="state"
                    className="form-control mb-3"
                    placeholder="State"
                    value={form.state}
                    onChange={handleChange}
                  />

                  <input
                    name="district"
                    className="form-control mb-3"
                    placeholder="District"
                    value={form.district}
                    onChange={handleChange}
                  />

                  <input
                    name="village"
                    className="form-control mb-3"
                    placeholder="Village"
                    value={form.village}
                    onChange={handleChange}
                  />

                  <input
                    name="land_size"
                    className="form-control mb-3"
                    placeholder="Land Size (Acres)"
                    value={form.land_size}
                    onChange={handleChange}
                  />

                  <input
                    name="primary_crop"
                    className="form-control mb-3"
                    placeholder="Primary Crop"
                    value={form.primary_crop}
                    onChange={handleChange}
                  />

                  <button
                    className="btn btn-success w-100 py-2"
                    disabled={loading}
                  >
                    {loading ? "Registering..." : "Register"}
                  </button>
                </form>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Register;